import { nextTick, onMounted, onActivated } from 'vue';

export function onMountedOrActivated(hook) {
  let isMounted;

  onMounted(() => {
    hook();
    nextTick(() => {
      isMounted = true;
    });
  });

  onActivated(() => {
    if (isMounted) {
      hook();
    }
  });
}
